var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
import { leaseMode as leaseModes } from '../../constant/common-type';
import cookie from '../../cookie/cookie';
import contractView from '../../components/contract/contract-view.vue';
import contractBoard from '../../components/console-common/contract-board.vue';
export default Vue.extend({
    name: 'login',
    components: {
        'el-contract-view': contractView,
        'el-contract-board': contractBoard,
    },
    data: function () {
        return {
            labelPosition: 'top',
            replaceSingleImport: {
                criteria: '',
            },
            contractData: [],
            contractDataOrigin: [],
        };
    },
    computed: __assign({}, mapState('contract', {
        contractDetailVague: 'contractDetailVague',
    }), mapState('repayment', {
        contractCode: 'contractCode',
    }), { isAddPlan: function () {
            var status = this.contractDetailVague.status;
            return !status || status === 'TERMINATED';
        } }),
    created: function () {
        this.getUserName();
        this.defaultQuery();
    },
    mounted: function () {
        this.clearRepaymentStatus();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        defaultQuery: function () {
            var contractCode = this.contractCode;
            if (contractCode) {
                this.replaceSingleImport.criteria = contractCode;
                this.detectionContractCode();
            }
        },
        clearRepaymentStatus: function () {
            this.$store.commit('repayment/update', {
                isCreate: false,
                isDisabledAddBatch: false,
                alreadyCreateNewPlanAmount: 0,
                isHasEdit: false,
                isOpenCreate: false,
                isOpensingleCreate: false,
            });
        },
        detectionContractCode: function () {
            var criteria = this.replaceSingleImport.criteria;
            this.$store.dispatch('contract/GET_CONTRACTDETAIL_VAGUE', {
                criteria: criteria,
                callback: this.getContractList,
            });
            this.$store.commit('contract/update', {
                contractDetailVague: {},
            });
        },
        getContractList: function (data) {
            var _this = this;
            if (data.length <= 0) {
                return;
            }
            this.contractDataOrigin = data;
            this.contractData = [];
            data.forEach(function (item) {
                var obj = {
                    orderNo: '',
                    status: '',
                    active: false,
                    list: [],
                };
                obj.orderNo = item.contractCode;
                obj.status = item.activeState;
                // obj.list.push(item)
                obj.list = [
                    {
                        key: '司机姓名',
                        val: item.driverName,
                    },
                    {
                        key: '车牌号',
                        val: item.plateNumber,
                        push: 3,
                    },
                    {
                        key: '注册手机号',
                        val: item.driverMobile,
                        span: 24,
                    },
                    {
                        key: '业务模式',
                        val: leaseModes[item.leaseMode],
                        span: 12,
                    },
                    {
                        key: item.leaseMode === 'JINGZU' ? '总租金' : '总额',
                        val: "\uFFE5" + _this.$utils.toYuan(item.totalAmount),
                        push: 3,
                    },
                    {
                        key: '合同有效期',
                        val: moment(item.startTime).format('YYYY-MM-DD') + " \u81F3 " + moment(item.endTime).format('YYYY-MM-DD'),
                        span: 24,
                    },
                ];
                _this.contractData.push(obj);
            });
        },
        getCurrentContract: function (index) {
            this.contractData.forEach(function (item) {
                item.active = false;
            });
            this.contractData[index]['active'] = true;
            this.$store.commit('contract/update', {
                contractDetailVague: this.contractDataOrigin[index],
            });
        },
        toAddPlan: function () {
            var contractCode = this.replaceSingleImport.contractCode;
            this.$emit('step-flag', {
                num: 1,
                contractCode: contractCode,
            });
            // this.$router.push({name:'repaymentCreate',params: this.contractData[0]})
        },
        sendAgreement: function (data) {
            var _this = this;
            var contractCode = data.contractCode, driverUid = data.driverUid;
            this.$request({
                method: 'post',
                url: '/proxy/api/contract/send',
                data: {
                    contractCode: contractCode,
                    driverUid: driverUid,
                },
            }).then(function (res) {
                if (!res || res.errorCode) {
                    _this.$message.error(!res ? '内部错误' : res.errorMsg);
                    return;
                }
                if (!res.errorCode) {
                    _this.detectionContractCode();
                    _this.$message({
                        message: '协议发送成功',
                        type: 'success',
                    });
                }
            });
        },
    },
    watch: {
        contractData: function (val) {
            if (val.length === 1) {
                this.getCurrentContract(0);
            }
        },
    },
});
